import { JSONSchema7 } from 'json-schema';

export const dataEnricherDbLookupNodeConfigSchema: JSONSchema7 = {
    type: 'object',
    required: ["blockName", "commitId"],
    properties: {
        blockName: {
            type: 'string',
            title: 'Select Enricher - DB Lookup',
            enum: [],
        },
        commitId: {
            type: 'string',
            title: 'Select Commit',
            enum: [],
        },
        variablesMapping: {
            type: 'object',
            title: 'Variables Mapping',
            description: ' Drag and drop properties from the Source Schema on the right to the Target Schema on the left to customize mappings. By default, all properties are mapped to the root request.',
            additionalProperties: {
                type: 'string',
            },
        },
        activityConfig: {
            title: "",
            type: "object",
            properties: {
                retryPolicy: {
                    type: "object",
                    title: "Retry Policy",
                    properties: {
                        maximumAttempts: {
                            type: "number",
                            title: "Maximum Attempts",
                            description: "Number of retry attempts before failing.",
                            default: 1, // Unlimited retries
                        },
                        initialInterval: {
                            type: "number",
                            title: "Initial Interval (ms)",
                            description: "Time before the first retry (ms)",
                            default: 1000, // 1 second
                        },
                        backoffCoefficient: {
                            type: "number",
                            title: "Backoff Coefficient",
                            description: "Multiplier for increasing the retry interval.",
                            default: 2,
                        },
                        maximumInterval: {
                            type: "number",
                            title: "Maximum Interval (ms)",
                            description: "Maximum time between retries (ms)",
                            default: 100000, // 100 seconds
                        },
                    },
                },
                timeouts: {
                    type: "object",
                    title: "Timeouts",
                    properties: {
                        startToCloseTimeout: {
                            type: "number",
                            title: "Start to Close Timeout (ms)",
                            description: "Maximum time for an activity to complete after it starts, in milliseconds.",
                            default: 10000, // Must be specified
                        },
                        scheduleToStartTimeout: {
                            type: "number",
                            title: "Schedule to Start Timeout (ms)",
                            description: "Time allowed for an activity to be picked up by a worker after being scheduled, in milliseconds.",
                            default: 10000, // Defaults to scheduleToCloseTimeout or unlimited
                        },
                        scheduleToCloseTimeout: {
                            type: "number",
                            title: "Schedule to Close Timeout (ms)",
                            description: "Maximum time from when an activity is scheduled to when it must be completed, in milliseconds.",
                            default: 10000, // Must be specified
                        },
                        heartbeatTimeout: {
                            type: "number",
                            title: "Heartbeat Timeout (ms)",
                            description: "Time interval between required heartbeats, in milliseconds.",
                            default: 86, // Must be specified if heartbeating is used
                        },
                    },
                },
                taskQueue: {
                    type: "object",
                    title: "Task Queue",
                    properties: {
                        taskQueueName: {
                            type: "string",
                            title: "Task Queue Name",
                            description: "Name of the Task Queue.",
                            default: "", // Defaults to the current worker's task queue
                        },
                    },
                },
                advancedSettings: {
                    type: "object",
                    title: "Advanced Settings",
                    properties: {
                        cancellationType: {
                            type: "string",
                            enum: ["TRY_CANCEL", "WAIT_CANCELLATION_COMPLETED", "ABANDON"],
                            title: "Cancellation Type",
                            description: "Defines the behavior when an activity is cancelled.",
                            default: "TRY_CANCEL",
                        },
                        heartbeatEnabled: {
                            type: "boolean",
                            title: "Enable Heartbeats",
                            description: "Toggle heartbeats on or off.",
                            default: false,
                        },
                    },
                },
            },
        },
    },
};



export const dataEnricherDbLookupNodeConfigUiSchema = {
    variablesMapping: {
        "ui:widget": "textarea",
        "ui:options": {
            rows: 5,
        },
    },
    activityConfig: {
        retryPolicy: {
            maximumAttempts: {
                "ui:widget": "updown",
                "ui:options": {
                    inputProps: { min: 0 }, // 0 for unlimited retries
                },
            },
            initialInterval: {
                "ui:widget": "text",
                "ui:placeholder": "e.g., 5s",
            },
            backoffCoefficient: {
                "ui:widget": "updown",
                "ui:options": {
                    step: 0.1,
                },
            },
            maximumInterval: {
                "ui:widget": "text",
                "ui:placeholder": "e.g., 1m",
            },
        },
        timeouts: {
            startToCloseTimeout: {
                "ui:widget": "text",
                "ui:placeholder": "e.g., 30s",
            },
            scheduleToStartTimeout: {
                "ui:widget": "text",
                "ui:placeholder": "e.g., 1m",
            },
            scheduleToCloseTimeout: {
                "ui:widget": "text",
                "ui:placeholder": "e.g., 2m",
            },
            heartbeatTimeout: {
                "ui:widget": "text",
                "ui:placeholder": "e.g., 10s",
            },
        },
        taskQueue: {
            taskQueueName: {
                "ui:widget": "text",
                "ui:placeholder": "e.g., my-task-queue",
            },
        },
        advancedSettings: {
            cancellationType: {
                "ui:widget": "select",
            },
            heartbeatEnabled: {
                "ui:widget": "checkbox",
            },
        },
    },
};
